<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form #dialogForm="ngForm">
                <div class="form-container">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Clé de l'en-tête HTTP</mat-label>
                            <input
                                matInput
                                type="text"
                                [(ngModel)]="item.key"
                                name="headerKey"
                                required
                                autocomplete="false"
                                tabindex="2"
                                appNoFocusContextMenu
                                (contextmenu)="$event.preventDefault(); onInputRightClick('key', $event)" />
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>Valeur de l'en-tête HTTP</mat-label>
                            <input
                                matInput
                                type="text"
                                placeholder="Valeur de l'en-tête HTTP"
                                [(ngModel)]="item.value"
                                name="headerValue"
                                required
                                autocomplete="false"
                                tabindex="3"
                                appNoFocusContextMenu
                                (contextmenu)="$event.preventDefault(); onInputRightClick('value', $event)" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>

<app-multi-level-context-menu
    [isRootNode]="true"
    [nodeData]="contextMenuItems"
    (onContextMenuItemClick)="handleMenuItemClick($event)"
    (onClosed)="CloseContextMenu()"></app-multi-level-context-menu>
